var aws = require('aws-sdk');

var rscBucketName = 'pepa.evdc';

function config() {

  var rscBucketRegion = 'eu-west-1';
  var rscIdentityPoolId = 'eu-west-1:233e356f-e3c9-4e3a-94ea-0f2450764304';

  AWS.config.update({
    region: rscBucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: rscIdentityPoolId
    })
  });

  var s3 = new AWS.S3({ apiVersion: 'latest' });
  return s3
}


const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_COMPLETE = 3;
const STATUS_FAILED = 4;

export const fileEvidenceMixin = {
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isComplete() {
      return this.currentStatus === STATUS_COMPLETE;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  data() {
    return {
      completedPercentage: 0,
      currentStatus: null,
      fileName: '',
      fileType: ''
    }
  },
  mounted() {
    this.currentStatus = STATUS_INITIAL;
  },

  methods: {
    async uploadEvidence(formData, identifier) {
      this.currentStatus = STATUS_SAVING
      var vm = this
      const files = formData.getAll('file');

      var file = files[0];
      var path = this.wordNumericValue(identifier);

      var ext =
        Math.random()
          .toString(36)
          .substring(2, 11) +
        "." +
        file.name.split(".").pop();

       this.fileType = file.type 
       this.fileName = file.name.replace(/\s/g, '_').replace(".", "_").toLowerCase() + ext;

      let remoteName = path + "/" + this.fileName;

      const filePath = "cognito/" + remoteName.trim();
      const type = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(file['type']) ? 'camera' : 'video'

      var params = {
        Bucket: rscBucketName,
        Key: filePath,
        ContentType: file.type,
        Body: file,
        ACL: "private",
        ServerSideEncryption: "AES256"
      };


//       console.log(file.type)
//       console.log(JSON.stringify(params))
// return

      //var s3 = config();
      // return new Promise((resolve, reject) => {
      //   s3.putObject(params, function (err, res) {
      //     if (err) reject(err);
      //     else resolve({ path: remoteName, filename: fileName, type: type });
      //   });
      // });

      console.log("UOADLIAD BW " , rscBucketName, filePath)

      var s3 = config();
      s3.upload(params)
      .on('httpUploadProgress', function (evt) {
          vm.completedPercentage = Math.round(evt.loaded / evt.total * 100);
          //console.log(`File uploaded: ${vm.completedPercentage}%`);
      }).send(function (err, data) {
          if (err) {
              // an error occurred, handle the error
              console.log(err, err.stack);
              vm.currentStatus = STATUS_FAILED;
              return;
          }

          vm.currentStatus = STATUS_COMPLETE;
      })

      
    },

    refreshUpload() {
      this.currentStatus = STATUS_INITIAL;
      this.file = ''
      this.remoteName = ''
    },
    completed() {
      this.currentStatus = STATUS_COMPLETE
    },
    setInitialStatus() {
      this.currentStatus = STATUS_INITIAL;
    },
    setSuccessStatus() {
      this.currentStatus = STATUS_SUCCESS;
    },
    setFailedStatus() {
      this.currentStatus = STATUS_FAILED;
    },
    wordNumericValue(n) {
      var alpha = "abcdefghijklmnopqrstuvwxyz".split('')
      var digits = Array.from(n.toString()).map(Number);

      var value = digits.map(v => {
        if (v >= 25) return "";
        return alpha[v];
      }).join("")

      var name = "pep" + value
      return name.toUpperCase()
    },


    encode(data) {
      var str = data.reduce(function (a, b) { return a + String.fromCharCode(b) }, '');
      return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
    },


    getStaticFile(remoteName) {

      const filePath = 'cognito/' + remoteName.trim();

      var headParams = {
        Bucket: rscBucketName,
        Key: filePath,
      };

      var params = {
        Bucket: rscBucketName,
        Key: filePath,
        Expires: 60
      };

      var s3 = config();

      return new Promise((resolve, reject) => {
        try {
          s3.headObject(headParams, function (err, data) {
            if (err) {
              reject(err)
            } else {
              s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) reject(err)
                else resolve(url)
              })

            }

          })

        } catch (e) {
          reject(e.message)
        }

      })
    },

    async getEvidenceFileFrom(remoteName, mimeType) {

      try {
        const filePath = 'cognito/' + remoteName.trim();
        var params = {
          Bucket: rscBucketName,
          Key: filePath
        };


        var s3 = config();
        const data = await s3.getObject(params).promise();


        return mimeType + this.encode(data.Body);
      } catch (e) {
        throw new Error(`Could not retrieve file from S3: ${e.message}`)
      }
    },


    async getEvidenceVideoFrom(remoteName, mimeType) {

      const filePath = 'cognito/' + remoteName.trim();

      var headParams = {
        Bucket: rscBucketName,
        Key: filePath,
      };

      var params = {
        Bucket: rscBucketName,
        Key: filePath
      };
      var s3 = config();
      return new Promise((resolve, reject) => {
        try {
          s3.headObject(headParams, function (err, data) {
            if (err) {
              reject(err)
            } else {
              s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) reject(err)
                else resolve(url)
              })

            }

          })

        } catch (e) {
          reject(e.message)
        }

      })
    },

  },
}